import { Stack, Switcher } from '@nearst/ui';
import * as Stats from '@components/StatsCard';
import { useInsightsDate } from '@services/InsightsDateProvider';
import { useProductFreeListings } from '@services/insights';
import { useShop } from '@services/ShopProvider';

import actionBar from '@assets/actions-bar.svg';
import stars from '@assets/stars.svg';

import InsightCardContainer from '../../components/InsightCardContainer';
import ActiveProductsCount from '../ActiveProductsCount';
import { ProductCard, DefaultProductCard } from './ProductCard';

import styles from './SwisScreenshot.module.scss';

const Active = ({ shop }) => {
	const { to, from } = useInsightsDate();
	const { resultSet, isLoading } = useProductFreeListings({ id: shop.id, to, from });
	const sortedResultSet = resultSet ? [...resultSet].sort((a, b) => b.impressions - a.impressions) : [];
	const topThreeBarcodes = sortedResultSet.slice(0, 3).map((item) => item.barcode);

	return (
		<InsightCardContainer>
			<Stack>
				<Stats.Header>
					<div>
						<Stats.Title>See What&apos;s in Store</Stats.Title>
						<Stats.Subtitle>Products shown on your Google Business Profile</Stats.Subtitle>
					</div>
				</Stats.Header>
				<Switcher>
					<ActiveProductsCount shop={shop} />
				</Switcher>
				<div className={styles.swisMockUpContainer}>
					<div className={styles.swisMockUpBorder}>
						<div className={styles.swisMockUpTextContainer}>
							<div>
								<p className={styles.swisMockUpText}>{shop.name}</p>
								<img src={stars} alt="5 stars" />
							</div>
							<div className={styles.swisProfileSquare}></div>
						</div>
						<div className={styles.swisMockUpActionBar}>
							<img src={actionBar} alt="Actions bar" />
						</div>
					</div>
					<div className={styles.swisMockUpProductRow}>
						{!isLoading && topThreeBarcodes.length === 3
							? topThreeBarcodes.map((barcode) => <ProductCard key={barcode} barcode={barcode} shopId={shop.id} />)
							: Array.from({ length: 3 }).map((_, key) => <DefaultProductCard key={key} />)}
					</div>
				</div>
			</Stack>
		</InsightCardContainer>
	);
};

const Teaser = () => {
	return (
		<InsightCardContainer>
			<Stack>
				<Stats.Header>
					<div>
						<Stats.Title>See What&apos;s in Store</Stats.Title>
						<Stats.Subtitle>Products shown on your Google Business Profile</Stats.Subtitle>{' '}
					</div>
				</Stats.Header>
			</Stack>
		</InsightCardContainer>
	);
};

const SwisScreenshot = ({ teaser = false }) => {
	const { shop } = useShop();
	if (teaser) return <Teaser />;
	return <Active shop={shop} />;
};

export default SwisScreenshot;
